export default "__VITE_ASSET__DAorvS2q__"